/** Tailwind `lg` — desktop shell (sidebar) vs mobile companion (tab bar). */
export const DESKTOP_LAYOUT_MIN_WIDTH_PX = 1024;

export const DESKTOP_LAYOUT_MEDIA = `(min-width: ${DESKTOP_LAYOUT_MIN_WIDTH_PX}px)`;
